import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "g-row g-row--appearance_spaced g-row--space_sm g-row--space_lg-lg g-row--space_2xl-fhd filter-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "prepend", { cols: "12" }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filters, (filter) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        ($setup.nodes[filter.id])
          ? (_openBlock(), _createElementBlock("div", {
              class: "g-cell g-cols g-cols--12 g-cols--6-sm g-cols--spread-sm g-cols--4-md g-cols--3-xl cabinet-filter-width",
              key: filter.id
            }, [
              ($setup.nodes[filter.id])
                ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.nodes[filter.id].component), _mergeProps({
                    key: 0,
                    ref_for: true
                  }, $setup.nodes[filter.id].props, {
                    key: `${filter.id}_${$props.value && $props.value[filter.id] || '1'}`
                  }), null, 16))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 256)),
    _renderSlot(_ctx.$slots, "append", {
      cols: "12",
      value: $props.value,
      filters: $props.filters
    })
  ]))
}